module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-moderator-0b99199ea807a83ebb0048a44105b48e.png";